/**
 * Login
 */
import React, { useState, useEffect } from 'react';
import { Axios } from '../utils/UtilityFunctions'
import { saveAs } from 'file-saver';

import { Button, Grid, Container, Paper, Table, TableCell, TableContainer, TableHead, TableRow, TableBody, InputLabel } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { EmailOutlined, LockOpen, LockOutlined } from '@material-ui/icons';
import { useHistory } from "react-router-dom";




const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});





export default function DownloadFile() {


    const classes = useStyles();
    const [page, setPage] = useState(1);

    const csvColumns = [
        'deviceId',
        'deviceName',
        'deviceManufacturer',
        'deviceModel',
        'deviceStorage',
        'deviceCarrier',
        'deviceColor',
        'name',
        'email',
        'address1',
        'address2',
        'city',
        'state',
        'zip',
        'country',
        'phone',
        'purchaseOrder'
    ]

    return (
        <>
            <Container component="main" maxWidth="sm" className={classes.main}>
                <Button 
                variant="outlined" 
                onClick={async () => {
                    var blob = new Blob([csvColumns.join(',')], { type:"text/csv;charset=utf-8" });
                    saveAs(blob, "tradeInUploadTemplate.csv");
                }}>Download CSV Template</Button>
            </Container>

        </>
    );
}

